import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { startOfDay } from '@components/core-ui/form-elements/DatePicker/helpers/startOfDay';
import { TextDatePicker } from '@components/core-ui/form-elements/TextDatePicker';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { JobResponseDto, JobsService } from 'app/API';
import { useMemo, useState } from 'react';

import { DatePickerWrapper } from './styles/DatePickerWrapper';

type TProps = {
  job: JobResponseDto;
  onCancel: () => void;
  onSuccess: () => void;
};

export const EditDeadlineModal = ({ job, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { workspace } = useAuthContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deadline, setDeadline] = useState<string | null>(job.deadline ?? '');

  const workspaceId = job.workspaceId ?? workspace?.id ?? '';
  const minDate = useMemo(() => startOfDay(), []);
  const maxDate = useMemo(() => {
    const date = startOfDay();
    date.setFullYear(date.getFullYear() + 1);
    return date;
  }, []);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await call(
      JobsService.updateDeadline({
        wsid: workspaceId,
        jobId: job.id,
        requestBody: { deadline: deadline || null },
      }),
    );
    setIsSubmitting(false);
    onSuccess();
  };

  return (
    <ModalWrapper width="360px" overflow="visible">
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Edit Deadline</ModalTitle>
      <DatePickerWrapper>
        <TextDatePicker
          label="Deadline"
          dateFormat="MM/dd/yyyy"
          minDate={minDate}
          maxDate={maxDate}
          value={deadline || undefined}
          onChange={(date) => setDeadline(date || null)}
        />
      </DatePickerWrapper>
      <div className="flex gap-2.5">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button onClick={handleSubmit} style={{ width: '130px' }}>
          Save
        </Button>
      </div>
    </ModalWrapper>
  );
};
